import qs from 'qs'
import axios from './../index'

/**
 * @description 满赠专区
 * http://192.168.2.177:3000/project/21/interface/api/1757
 * @author txw
 * @date 2020-07-20
 * @export
 */
export function requestGiftslist (params) {
  return axios.post('/gifts/load-gifts-list', qs.stringify(params))
}
